"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePortal = exports.Portal = void 0;

var _react = require("react");

var _reactDom = require("react-dom");

var _bind = _interopRequireDefault(require("classnames/bind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./usePortal.css");

var _styles = {
  "portal": "usePortal__portal___3h30B"
};

const styles = _bind.default.bind(_styles);

const createRootElement = id => {
  const rootContainer = document.createElement('div');
  rootContainer.setAttribute('id', id);
  return rootContainer;
};

const addRootElement = rootElem => {
  document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
};

const usePortal = (id, className) => {
  const rootElemRef = (0, _react.useRef)();
  (0, _react.useEffect)(function setupElement() {
    const existingParent = document.querySelector(`#${id}`);
    const parentElem = existingParent || createRootElement(id);

    if (!existingParent) {
      addRootElement(parentElem);
    }

    parentElem.appendChild(rootElemRef.current);
    return function removeElement() {
      rootElemRef.current.remove();

      if (!parentElem.childElementCount) {
        parentElem.remove();
      }
    };
  }, [id]);
  const portal_classname = styles('portal').split(' ');

  const getRootElem = () => {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement('div');
      rootElemRef.current.classList.add(...portal_classname);

      if (className) {
        rootElemRef.current.classList.add(className);
      }
    }

    return rootElemRef.current;
  };

  return getRootElem();
};

exports.usePortal = usePortal;

const Portal = ({
  id,
  children,
  className
}) => {
  const target = usePortal(id, className);
  return (0, _reactDom.createPortal)(children, target);
};

exports.Portal = Portal;